export default __webpack_public_path__ + "static/media/cart.11df06a2.svg";